<app-nexleader-rali-frame
  *ngIf="group"
  [raliId]="getRaliId()"
></app-nexleader-rali-frame>
